import { authService } from '@zeus/react-common/lib/business/service/auth-service'
import { jwtService } from '@zeus/react-common/lib/business/service/jwt-service'
import { accessTokenService } from '@zeus/react-common/lib/business/service/token/access-token-service'
import { refreshTokenService } from '@zeus/react-common/lib/business/service/token/refresh-token-service'
import { browserUtil } from '@zeus/react-common/lib/util/browser-util'
import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import logo from 'src/asset/image/logo-dark.svg'
import { authServiceFactory } from 'src/business/service/auth-service'
import { Spinner } from 'src/component/util/spinner'
import style from 'src/screen/not-verified-screen/not-verified-screen.module.scss'

export const VerifyEmail = (): React.ReactElement => {
  const { code } = useParams()
  const navigate = useNavigate()
  const [noCode, setNoCode] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [succeed, setSucceed] = useState(false)

  const onSuccess = async (): Promise<void> => {
    setSucceed(true)
    try {
      const accessToken = await accessTokenService.get()
      const refreshToken = await refreshTokenService.get()
      if (!refreshToken || !accessToken) {
        setTimeout(() => navigate('/logout'), 3000)
        return
      }
      const { accessToken: newAccessToken } = await authService.refreshToken()
      await accessTokenService.store(newAccessToken)
      const { tenant } = jwtService.decode(newAccessToken)
      if (tenant) {
        const redirectPathParts = [`${tenant.type}`]
        if (tenant.type === 'haulier') redirectPathParts.push('verification')
        browserUtil.redirect(`/${redirectPathParts.join('/')}`)
      } else navigate('/logout')
    } catch (e) {
      navigate('/logout')
    }
  }

  useEffect(() => {
    if (!code) return setNoCode(true)
    setIsLoading(true)
    authServiceFactory()
      .verifyEmail({ code })
      .then(onSuccess)
      .catch((error) => {
        setNoCode(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])
  return (
    <>
      <Container fluid={true}>
        {noCode && (
          <div className={`d-flex aligin-items-center justify-content-center w-100 vh-100`}>
            <img src={logo} className={style.logo} />
            <h1 className="pt-5">Provided verification code is not valid or expired.</h1>
          </div>
        )}
        {succeed && (
          <div className={`d-flex aligin-items-center justify-content-center w-100 vh-100`}>
            <img src={logo} className={style.logo} />
            <h1 className="pt-5">Successful. Login to continue.</h1>
          </div>
        )}
      </Container>
      {isLoading && <Spinner />}
    </>
  )
}
